var BASE_URL = process.env.BASE_URL;
// var BASE_URL = 'http://192.168.31.118:8080/';
let STORE_URL = process.env.STORE_BASE_URL;
let GETWAY_URL = process.env.GETWAY_URL;
let LOGIC_URL = process.env.LOGIC_URL;
let ESHOP_URL = process.env.ESHOP_URL;
let PAY_URL = process.env.BASE_URL;
let BACK_URL = process.env.BACK_URL;
let SEARCHING_KEY_URL = BASE_URL;
console.log("env_config", process.env.ENV_CONFIG);
const API = {
  activity: {
    add: `${BASE_URL}/back/activity/add`,
    addChannel: `${BASE_URL}/back/activity/addChannel`,
    channelList: `${BASE_URL}/back/activity/channelList`,
    detail: `${BASE_URL}/back/activity/detail`,
    list: `${BASE_URL}/back/activity/list`,
    update: `${BASE_URL}/back/activity/update`,
    report: `${BASE_URL}/back/activity/report`
  },
  guide: {
    guideList: () => {
      return `${BASE_URL}/v2/guide/list`;
    },
    guideUpdate: () => {
      return `${BASE_URL}/v2/guide/update`;
    }
  },
  common: {
    getStoreDetail: `${GETWAY_URL}/auth/v2/store/mini/detail`
  },
  plp: {
    // getPdpById: `${BASE_URL}/back/activity/add`,
    // getPdpById: `https://uat-gateway.getconnectplus.com/cplus/page/detail`,
    productDetailList: () => {
      return `${BACK_URL}/dbc/mini/back/product/cmslist`;
    },
    // getProcutList: 'https://uat-gateway.getconnectplus.com/dbc/mini/back/product/cmslist',
    getPageDetailById: `${BASE_URL}/page/getDetails`,
    getHeadAndFoot: `${BASE_URL}/page/getHeadAndFoot`,
    getMixByProductId: `${BASE_URL}/productMixApi/getMixByProductId`,
    getEntityIdByLinkUrl: () => {
      return `${BASE_URL}/friendlyUrl/getByLinkAndType`;
    },
    getFooterTextByEntityId: () => {
      return `${BASE_URL}/friendlyUrl/xxxxx`;
    },
    getAllWithCollection: `${GETWAY_URL}/dbc/mini/goodsGuide/getAllWithCollection`,
    getProductListWithGroup: `${BASE_URL}/productBase/getProductListWithGroup`,
    getProductListWithCollection: `${BASE_URL}/productBase/getProductListWithCollection`,
    getProductListWithBrand: `${BASE_URL}/productBase/getProductListWithBrand`,
    getSpectByType: `${BASE_URL}/productBase/getSpectByType`,
    getAllByTagName:`${ESHOP_URL}/goodsGuide/getAllByTagName`
  },
  my: {
    getAllAreas: `${STORE_URL}/areas/getAllAreas`,
    saveAddress: `${GETWAY_URL}/dbc/mini/userInfo/saveAddress`,
    getAddressList: `${GETWAY_URL}/dbc/mini/userInfo/getAddressByOpenId`,
    deleteAddress: `${GETWAY_URL}/dbc/mini/userInfo/deleteAddress`,
    addWish: `${ESHOP_URL}/collection/tb/do`,
    getWishList: `${ESHOP_URL}/collection/tb/list`,
    getUserInfo: `${BASE_URL}/userManager/login/userinfo`,
    updateUserInfo: `${BASE_URL}/userManager/updateUserInfo`,
    joinCrmMember: `${BASE_URL}/userManager/crmMember`,
    crmMemberRightBanner: `${BASE_URL}/asap/crmMemberRightBanner`,
    
  },
  pdp: {
    // GETWAY_URL
    getProductDetailById: `${ESHOP_URL}/product/getProduct`,
    getStocksAndPriceByType: `${ESHOP_URL}/product/getStocksAndPriceByType`, //通过规格设置价格和库存
    getSpecType: `${ESHOP_URL}/product/getSpecType`, //获取规格信息
    getDelivery: `${BASE_URL}/deliveryModeManager/one`,
    getCopyText: `${BASE_URL}/customizeCopyManager/one`,
    kezi: `${LOGIC_URL}/product/kezi`,
    getRecommendBases: `${ESHOP_URL}/product/getRecommendBases`,
    getSizeChart: `${ESHOP_URL}/sizeApiManager/getSizeByProductId`, //获取尺码表
    getKeziInfo:`${LOGIC_URL}//product/kezi`,
    getColorImages:`${ESHOP_URL}/product/getColorImages` //
    // /deliveryModeManager/one
  },
  shopcart: {
    //购物车相关
    addCart: `${GETWAY_URL}/dbc/mini/cart/add`,
    cartList: `${GETWAY_URL}/dbc/mini/cart/list`,
    deleteCart: `${GETWAY_URL}/dbc/mini/cart/delete`
  },
  checkout: {
    //
    checkoutByCart: `${GETWAY_URL}/dbc/mini/order/checkoutByCart`,
    checkout:`${GETWAY_URL}/dbc/mini/order/checkout`,
    createOrder: `${ESHOP_URL}/orderWeb/createOrder`
  },
  order: {
    orderList: `${GETWAY_URL}/dbc/mini/order/getOrderList`,
    orderDetail: `${GETWAY_URL}/dbc/mini/order/detail`,
    getOrderId: `${BASE_URL}/productPayApi/getByOutTradeNo`,
    cancelOrder: `${GETWAY_URL}/dbc/mini/order/cancelOrder`,
    queryLogistics: `${LOGIC_URL}/logistics/get`,
    refundDetail: `${GETWAY_URL}/dbc/mini/refund/detail`,
    getCustomerId: `${BASE_URL}/userManager/phone`,
    getHistoryOrderList: `${BASE_URL}/page/getOrderList`,
    getHistoryOrderDetail: `${BASE_URL}/page/getOrderDetails`
  },
  sys: {
    getNonExistentList: `${BASE_URL}/nonExistent/list`,
    getNoticeInfo: `${BASE_URL}/noticeManager/one`,
    getSystemPageList: `${BASE_URL}/systemPageManager/list`,
    getSystemPageInfo: `${BASE_URL}/systemPageManager/one`,
    getGolbalText: `${BASE_URL}/bottomGuide/global`,
    // getFooterTextByEntityId: () => { return `${BASE_URL}/bottomGuide/getByPositionId` },
    getByTextPositionId: `${BASE_URL}/bottomGuide/getByPositionId`
  },
  blogs: {
    getBlogPageDetail: `${BASE_URL}/page/getLogDetails`,
    getBlogList: `${BASE_URL}/page/getLogMuster`,
    getBlogTags: `${BASE_URL}/page/getLogMusterTags`
  },
  customer: {
    saveClientInfo: `${BASE_URL}/customizationManager/add`, //量身定制
    getVerifyCode: `${BASE_URL}/userManager/verifyCode`, //获取验证码
    register: `${BASE_URL}/userManager/reg/personal`, //个人用户注册
    login: `${BASE_URL}/userManager/login/personal`, //个人用户登录
    subscribe: `${BASE_URL}/userManager/subscribe`, //订阅资讯
    subSet: `${BASE_URL}/userManager/subscribePreference`, //订阅偏好,
    sendMail: `${BASE_URL}/userManager/send`, //发送绑定email邮件,
    checkMail: `${BASE_URL}/userManager/check`, //检验email邮件,
    bind: `${BASE_URL}/userManager/bind` //通过邮箱绑定用户信息,
  },
  atlas: {
    getAtlasList: `${BASE_URL}/atlasManager/atlas/allList`, //查询所有图集List,女:1,男:0,不传返回所有
    getAtlas: `${BASE_URL}/atlasManager/atlasInfo`, //获取一个图集信息
    getAtlasId: `${BASE_URL}/friendlyUrl/getByLinkAndType` //获取图集ID
  },
  store: {
    getStoreList: `${STORE_URL}/storePc/getList`, //获取门店列表
    getStoreDetail: `${STORE_URL}/storePc/getOne`, //获取门店详情
    getStoreDetailByFriendlyUrl: `${STORE_URL}/storePc/getByFriendlyUrl` //根据friendlyurl获取门店详情
  },
  recommendSearching: {
    getRecommendSearchingList: `${SEARCHING_KEY_URL}/recommendation/api/list`, //获取推荐搜索词列表
    searchKeyWord: `${SEARCHING_KEY_URL}/recommendation/api/categorySearch`, //搜索关键词
    searchProductAPart: `${SEARCHING_KEY_URL}/recommendation/api/searchPart`, //搜索部分商品
    searchProductAll: `${SEARCHING_KEY_URL}/recommendation/api/searchAll` //搜索所有商品
  },
  pay: {
    wechatPay: `${PAY_URL}/productPayApi/makePayOrder/`, //发起支付-微信支付
    wechatCheck: `${PAY_URL}/productPayApi/checkOrder/` //轮询订单是否支付成功
  },
  tracking:{
    addTb: `${ESHOP_URL}/activityRecord/add/tb`,
    getIp:  `${ESHOP_URL}/activityRecord/getIp`,
    tbMiss:`${ESHOP_URL}/activityRecord/add/tbMiss`,
    searchLogAdd:`${ESHOP_URL}/searchLog/add/tb`
  },
  instoreOffline:{
    validatePhone:`${BASE_URL}/tbInstoreOffline/phone/validate`,
    staffDetail:`${BASE_URL}/tbInstoreOffline/staff/detail`,
    areaCode:`${BASE_URL}/tbInstoreOffline/areacode/list`,
    regionlist:`${BASE_URL}/tbInstoreOffline/region/list`,
    storeList:`${BASE_URL}/tbInstoreOffline/store/list`,
    register: `${BASE_URL}/tbInstoreOffline/user/register`
  },
  black:{
    getBlackTip:`${ESHOP_URL}/white/copy/get`,
    getUserBlack:`${ESHOP_URL}/user/white/detail`,
  },
  mtmInfo:{
    add: `${ESHOP_URL}/userMtmInfo/add`,
  }
 

};

export default API;



// WEBPACK FOOTER //
// ./src/service/api.js